import { Icon } from '@chakra-ui/react';
import { MdLock } from 'react-icons/md';

// Auth Imports
import AuthCentered from 'layouts/auth/types/Centered';
import { IoBookmarksOutline } from 'react-icons/io5';
import { MdLogout } from 'react-icons/md';
import { RxDashboard, RxHome, RxPerson } from 'react-icons/rx';
import ConfirmEmail from 'views/auth/confirmEmail';
import ConfirmWithdrawal from 'views/auth/confirmWithdrawal';
import ForgotPassword from 'views/auth/forgotPassword';
import SignIn from 'views/auth/signIn';
import SignUp from 'views/auth/signUp';
import UnsubscribeEmail from 'views/auth/unsubscribeEmail';
import Verification from 'views/auth/verification';
import Activity from 'views/client/activity';
import BrandDashboard from 'views/client/brands';
import BrandDetail from 'views/client/brands/BrandDetail';
import Dispute from 'views/client/dispute';
import Education from 'views/client/education';
import BitcoinBasics from 'views/client/education/components/BitcoinBasics';
import Cashback from 'views/client/education/components/Cashback';
import Lightning from 'views/client/education/components/Lightning';
import Security from 'views/client/education/components/Security';
import WhyCashback from 'views/client/education/components/WhyCashback';
import BumbeiFAQ from 'views/client/faqs';
import Profile from 'views/client/profile';
import Rewards from 'views/client/rewards';
import Wallet from 'views/client/wallet';
import Welcome from 'views/client/welcome';

const routes = [
	// --- CLIENT --- //
	{
		name: 'Inicio',
		layout: '/client',
		path: '/home',
		icon: <Icon as={RxHome} width='20px' height='20px' color='inherit' />,
		component: <Welcome />,
	},
	{
		name: 'Marcas',
		layout: '/client',
		path: '/dashboard',
		icon: <Icon as={RxDashboard} width='20px' height='20px' color='inherit' />,
		component: <BrandDashboard />,
	},
	{
		name: 'Brand Detail',
		layout: '/client',
		path: '/dashboard/detail',
		icon: <Icon as={RxDashboard} width='20px' height='20px' color='inherit' />,
		component: <BrandDetail />,
		hide: true,
	},

	// --- MY ACCOUNT --- //
	{
		name: 'Mi cuenta',
		path: '/profile',
		icon: <Icon as={RxPerson} width='20px' height='20px' color='inherit' />,
		collapse: true,
		items: [
			{
				name: 'Datos',
				layout: '/client',
				path: '/profile/overview',
				component: <Profile />,
			},
			{
				name: 'Actividad',
				layout: '/client',
				path: '/profile/activity',
				component: <Activity />,
			},
			{
				name: 'Cartera',
				layout: '/client',
				path: '/profile/wallet',
				component: <Wallet />,
			},
			{
				name: 'Disputas',
				layout: '/client',
				path: '/profile/dispute',
				component: <Dispute />,
			},
		],
	},

	// --- EDUCATION --- //
	{
		name: 'Aprende',
		path: '/education',
		icon: (
			<Icon
				as={IoBookmarksOutline}
				width='20px'
				height='20px'
				color='inherit'
			/>
		),
		collapse: true,
		items: [
			// --- Education Center ---
			{
				name: 'Rewards',
				layout: '/client',
				path: '/education/bumbei-rewards',
				component: <Rewards />,
			},
			{
				name: 'Educación',
				layout: '/client',
				path: '/education/center',
				component: <Education />,
			},
			{
				name: 'FAQs',
				layout: '/client',
				path: '/education/faqs',
				component: <BumbeiFAQ />,
			},
		],
	},
	{
		name: 'Bitcoin',
		layout: '/client',
		path: '/education/bitcoin-basics',
		component: <BitcoinBasics />,
		hide: true,
	},
	{
		name: 'Lightning Network',
		layout: '/client',
		path: '/education/lightning',
		component: <Lightning />,
		hide: true,
	},
	{
		name: 'Seguridad & Privacidad',
		layout: '/client',
		path: '/education/security',
		component: <Security />,
		hide: true,
	},
	{
		name: 'Gana más cashback',
		layout: '/client',
		path: '/education/cashback',
		component: <Cashback />,
		hide: true,
	},
	{
		name: '¿Por qué cashback?',
		layout: '/client',
		path: '/education/why-cashback',
		component: <WhyCashback />,
		hide: true,
	},

	// --- EDUCATION STAND ALONE --- //
	{
		name: 'Bitcoin',
		layout: '/',
		path: '/education/bitcoin-basics',
		component: (
			<AuthCentered includeBtns cardBottom='50px'>
				<BitcoinBasics />
			</AuthCentered>
		),
		hide: true,
	},
	{
		name: 'Lightning Network',
		layout: '/',
		path: '/education/lightning',
		component: (
			<AuthCentered includeBtns cardBottom='50px'>
				<Lightning />
			</AuthCentered>
		),
		hide: true,
	},
	{
		name: 'Seguridad & Privacidad',
		layout: '/',
		path: '/education/security',
		component: (
			<AuthCentered includeBtns cardBottom='50px'>
				<Security />
			</AuthCentered>
		),
		hide: true,
	},
	{
		name: 'Gana más cashback',
		layout: '/',
		path: '/education/cashback',
		component: (
			<AuthCentered includeBtns cardBottom='50px'>
				<Cashback />
			</AuthCentered>
		),
		hide: true,
	},
	{
		name: 'Preguntas frecuentes',
		layout: '/',
		path: '/education/faqs',
		component: (
			<AuthCentered includeBtns fullW cardBottom='50px'>
				<BumbeiFAQ />
			</AuthCentered>
		),
		hide: true,
	},
	{
		name: '¿Por qué cashback?',
		layout: '/',
		path: '/education/why-cashback',
		component: (
			<AuthCentered includeBtns fullW cardBottom='50px'>
				<WhyCashback />
			</AuthCentered>
		),
		hide: true,
	},

	// --- AUTHENTICATION --- //
	{
		name: 'Authentication',
		path: '/auth',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		collapse: true,
		items: [
			// --- Sign In ---
			{
				name: 'Sign In',
				layout: '/auth',
				path: '/sign-in',
				component: <SignIn />,
			},
			// --- Sign Up ---
			{
				name: 'Sign Up',
				path: '/sign-up',
				layout: '/auth',
				component: <SignUp />,
			},
			// --- Verification ---
			{
				name: 'Verification',
				layout: '/auth',
				path: '/verification',
				component: <Verification />,
			},
			// --- Forgot Password ---
			{
				name: 'Forgot Password',
				layout: '/auth',
				path: '/forgot-password',
				component: <ForgotPassword />,
			},
			// --- Confirm email ---
			{
				name: 'Confirm email',
				layout: '/auth',
				path: '/confirm-email',
				component: <ConfirmEmail />,
			},
			// --- Unsubscribe email ---
			{
				name: 'Unsubscribe email',
				layout: '/auth',
				path: '/unsubscribe-email',
				component: <UnsubscribeEmail />,
			},
			// --- Confirm withdrawal ---
			{
				name: 'Confirm withdrawal',
				layout: '/auth',
				path: '/confirm-withdrawal',
				component: <ConfirmWithdrawal />,
			},
		],
	},

	// --- LOGOUT --- //
	{
		name: 'Logout',
		layout: '',
		path: '',
		icon: <Icon as={MdLogout} width='20px' height='20px' color='inherit' />,
		action: 'logout',
	},
];

export default routes;
